import { activityHistoryCollectionsSlice } from "../slice";

export const { updateActivityHistoryItem } = activityHistoryCollectionsSlice.actions;
